const rh = (acao) => ({ modulo: 'rh', acao });
/** Dados e relatórios do RH (horas extras e absenteísmo). */
export const RH_DADOS_PERMISSIONS = [rh('visualizar')];
/**
 * Consulta do plano de contingência.
 * `acessar` abre o módulo; `editar_nivel_risco` opera o mapa.
 */
export const RH_PLANO_CONTINGENCIA_PERMISSIONS = [
    rh('acessar'),
    rh('visualizar'),
    rh('editar_nivel_risco'),
];
/** Qualquer uma destas mostra o grupo RH no menu. */
export const RH_MODULE_ENTRY_PERMISSIONS = [
    rh('acessar'),
    rh('visualizar'),
    rh('editar_nivel_risco'),
];
export function temAlgumaPermissaoRh(hasPermission, permissoes) {
    return permissoes.some(permissao => hasPermission(permissao.modulo, permissao.acao));
}
